import { createEmptyCart, getProducts, addProductToCart } from './utils/graphql';
import { getMindboxPrices, type LandingPriceInfo } from './_mindbox';

const $productNotification = document.querySelector('[data-role=notification]') as HTMLDivElement;
const $productName = $productNotification.querySelector('[data-role=product-name]');
const $productImage = $productNotification.querySelector('[data-role=product-image]') as HTMLImageElement;
const $productPricePopup = $productNotification.querySelector('[data-role=regular-price]');
const $productBasePricePopup = $productNotification.querySelector('[data-role=old-price]');
const $cartQty = document.querySelector('[data-role=cart-counter]');
const cart: Record<string, number> = {};
const $closeButton = document.querySelectorAll('[data-role=close-button]');

declare let productsSku: string[];

const skusArr = [...new Set(productsSku)];
let pricesCache: Record<string, LandingPriceInfo> = {};

function showAddToCartError(sku: string) {
	alert(`Не удалось добавить товар с артикулом ${sku} в корзину. Попробуйте позже.`);
}

const formatPrice = (price: string | number): string => {
	const num = Number(price);
	return num.toLocaleString('ru-RU', {
		useGrouping: true,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).replace(/\u00A0/g, ' ');
};

const applyProductPrice = (
	sku: string,
	priceInfo: LandingPriceInfo | undefined,
	stockStatus?: string
) => {
	if (!priceInfo) {
		return;
	}

	const regularPrice = priceInfo.basePrice;
	const finalPrice = priceInfo.finalPrice ?? priceInfo.basePrice;
	const $productPrices = document.querySelectorAll(`[data-role=product-price-${sku}]`);
	const $productBasePrices = document.querySelectorAll(`[data-role=product-base-price-${sku}]`);

	$productPrices.forEach($productPrice => {
		if (typeof $productPrice.textContent === 'string') {
			$productPrice.textContent = `${formatPrice(finalPrice)} ₽`;
		}
	});

	$productBasePrices.forEach($productBasePrice => {
		if (
			regularPrice > finalPrice
			&& typeof $productBasePrice.textContent === 'string'
		) {
			$productBasePrice.textContent = `${formatPrice(regularPrice)} ₽`;
		}
	});

	if (stockStatus === 'IN_STOCK') {
		$productPrices.forEach($productPrice => {
			$productPrice?.closest('form')?.classList.add('available');
		});
	}
};

const getProductsPrice = async () => {
	const products = await getProducts(skusArr);
	const prices = await getMindboxPrices(products);

	pricesCache = prices;

	products.forEach((product) => {
		applyProductPrice(product.sku, prices[product.sku], product.stock_status);
	});
};

document.addEventListener('submit', async (event) => {
	event.preventDefault();

	const $form = event.target as HTMLFormElement;

	if ($form.dataset.role !== 'add-to-cart-form') {
		return;
	}

	const formData = new FormData($form);
	const sku = formData.get('sku') as string | null;

	if (!sku) {
		return;
	}

	let cartId = document.cookie.match(/(?:^|\s*)cart_id=([^;]*)/)?.[1];

	if (!cartId) {
		cartId = await createEmptyCart();
		document.cookie = `cart_id=${cartId}; path=/; domain=${window.location.hostname}; SameSite=Lax; Secure`;
	}

	const quantity = cart[sku] ? cart[sku] + 1 : 1;
	const result = await addProductToCart(cartId, sku);

	if (!result) {
		showAddToCartError(sku);
		return;
	}

	cart[sku] = quantity;

	const cartItem = result?.addSimpleProductsToCart?.cart?.items.find(item => item.product.sku === sku);

	if (!cartItem) {
		showAddToCartError(sku);
		return;
	}

	const { product } = cartItem;
	const basketCount = Object.values(cart).reduce((sum, current) => sum + current, 0);

	if (typeof $productName?.textContent === 'string') {
		$productName.textContent = product.name;
	}

	if (product.image?.url && $productImage) {
		$productImage.src = product.image.url;
	}

	const priceInfo = pricesCache[sku];
	const regularPrice = priceInfo?.basePrice;
	const finalPrice = priceInfo?.finalPrice ?? priceInfo?.basePrice;

	if ($productPricePopup && finalPrice) {
		$productPricePopup.textContent = `${formatPrice(finalPrice)} ₽`;
	}

	if ($productBasePricePopup && regularPrice && finalPrice && regularPrice > finalPrice) {
		$productBasePricePopup.textContent = `${formatPrice(regularPrice)} ₽`;
	}

	if (basketCount && typeof $cartQty?.textContent === 'string') {
		$cartQty.textContent = String(basketCount);
	}

	$productNotification.classList.add('_show');
});

if ($closeButton) {
	$closeButton.forEach($button => {
		$button.addEventListener('click', () => {
			$productNotification.classList.remove('_show');
		});
	});
}

getProductsPrice();
